/**
 * Check if value is a string
 * @param {*} value Value to check
 * @param {number} [minLength=0] Minimal length of the string to be accepted
 * @returns {boolean}
 */
export default (value, minLength = 0) => {
	return typeof value === 'string' && value.length >= minLength;
};
